import BaseValidator from '@/app-core/lib/data/validator/BaseValidator'
import ValidatorTypesEnum from '@/app-core/lib/data/validator/ValidatorTypesEnum'
import {isValidMobilePhone} from '@/app-core/api/validations/CustomValidator'

export default class GuestValidator extends BaseValidator {
  validatorRules = {
    Id: {
      required: false,
      type    : ValidatorTypesEnum.Number
    },
    Firstname: {
      required: true,
      type    : ValidatorTypesEnum.String,
      minLen  : 2,
      maxLen  : 32
    },
    Lastname: {
      required: true,
      type    : ValidatorTypesEnum.String,
      minLen  : 2,
      maxLen  : 32
    },
    Email: {
      required: true,
      type    : ValidatorTypesEnum.Email,
      maxLen  : 96
    },
    Phone: {
      required   : true,
      type       : ValidatorTypesEnum.String,
      mobilePhone: isValidMobilePhone
    }
  }

  validatorMessages = {
    el: {
      mobilePhone: 'Πρέπει να είναι έγκυρος αριθμός κινητού τηλεφώνου'
    },
    en: {
      mobilePhone: 'Must be a valid mobile number'
    }
  }

  constructor(data = {}) {
    super(data)
  }
}
